import type { ScreeningCandidate } from "./types";

const FIELD_LABELS = {
  npi: "NPI",
  dateOfBirth: "Date of birth",
  licenseNumber: "License in source state",
};
const STATUS_LABELS = {
  match: "Agrees",
  different: "Differs — investigate",
  unavailable: "Not available for comparison",
  "not-comparable": "Needs manual comparison",
};
const NAME_LABELS = {
  exact: "Exact first and last name",
  similar: "Similar name",
  "weak-alias": "Weak alias",
};

export function ScreeningComparisons({
  candidate,
}: {
  candidate: ScreeningCandidate;
}) {
  if (!candidate.identityComparisons) {
    return null;
  }
  return (
    <div className="space-y-2 text-xs">
      <p className="font-medium">Comparison with captured provider identity</p>
      {candidate.nameMatch && (
        <p>{NAME_LABELS[candidate.nameMatch]} — identity not confirmed</p>
      )}
      <dl className="grid gap-2 sm:grid-cols-2">
        {candidate.identityComparisons.map((comparison) => (
          <div key={comparison.field}>
            <dt className="text-muted-foreground">
              {FIELD_LABELS[comparison.field]}
            </dt>
            <dd>{STATUS_LABELS[comparison.status]}</dd>
            {(comparison.providerValue || comparison.sourceValue) && (
              <dd className="break-words text-muted-foreground">
                Provider: {comparison.providerValue ?? "Not provided"}
                <br />
                Source: {comparison.sourceValue ?? "Not provided"}
              </dd>
            )}
          </div>
        ))}
      </dl>
    </div>
  );
}
